import React from 'react';
import './Loading.css';

const Loading = () => {
  return (
    <>
      <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      <p className="lds-roller" style={{ marginLeft: -80, marginTop: -25 }}>Processing request....please wait</p>
    </>
  )
}

export default Loading;